import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import Sun from '@mui/icons-material/LightMode';
import Box from '@mui/joy/Box';
import Chip from '@mui/joy/Chip';
import * as React from 'react';

export default function InsideValue() {
  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <Chip variant="soft" color='neutral' startDecorator={<TrendingFlatIcon />}>
        Inside Previous Value Area
      </Chip> 
    </Box>
  );
}